<template>
  <div class="modalContainer">
    <div class="printContainer" ref="printHideDomRef" v-show="!isShowImg">
      <div class="titleContainer">
        <h1 class="mainTitle">零 星 费 用 报 销 单</h1>
      </div>

      <div class="dateContainer">
        <div>报销日期: {{ this.ykDateFormat('yyyy-MM-dd', printData.r_date) }}</div>
        <div>公司: {{ printData.company }}</div>
      </div>

      <table class="mainTable">
        <tr>
          <td style="width: 150px;">
            <div class="contentContainer">
              <div class="left">粘贴单据</div>
              <div class="mid">{{ printData.document_count }}</div>
              <div class="right">张</div>
            </div>
          </td>
          <td>
            <div class="contentContainer">
              <div class="left">共计人民币(大写):&emsp;{{ this.amountLtoU(printData.amout) }}</div>
              <div class="mid"></div>
              <div class="right">(&nbsp;￥&nbsp;{{ this.$utils.commafy(printData.amout, { digits: 2 }) }}&nbsp;)</div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="padding: 0;">
            <table style="margin: 0;">
              <tr>
                <td style="border: 0; width: 80px;">
                  <div style="width: 100%;height: 100%;text-align: center;">
                    事 由
                  </div>
                </td>
                <td style="border: 0;border-left: 1px solid #000000;">
                  <div style="height: 180px;">{{ printData.subject_matter }}</div>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>

      <div class="footerContainer">
        <div class="signContainer">
          领导审批:
          <div class="signItems" v-html="lingdaoSign"></div>
        </div>
        <div class="signContainer">
          单位主管:
          <div class="signItems" v-html="lingongSign"></div>
        </div>
        <div class="signContainer">
          财务审核:
          <div class="signItems" v-html="caiwuSign"></div>
        </div>
        <div class="signContainer">
          报销人:
          <div class="signItems" v-html="userNameSign"></div>
        </div>
      </div>
    </div>

    <img id="printImgDom" style="cursor: pointer;width: 100%;" :src="imgSrc" @click="previewImg" v-show="isShowImg" />
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
// import SignObject from '../../public/utils/signJpg'
import { convertSign } from '../../public/utils/getSign'

export default {
  props: {
    printData: {
      type: Object
    }
  },
  data() {
    return {
      formVisible: false,
      imgSrc: '',
      // 打印签字
      caiwuSign: '',
      lingdaoSign: '',
      lingongSign: '',
      userNameSign: '',
      // 是否展示图片
      isShowImg: false
    }
  },
  methods: {
    // 预览图片
    previewImg() {
      this.$hevueImgPreview(this.imgSrc)
    },
    showModal() {
      this.handlePrint()
    },
    async handlePrint() {
      const { data: res } = await this.$http.get('/finance/users')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      const SignObject = convertSign(res.data)

      this.isShowImg = false

      this.caiwuSign = ''

      this.lingdaoSign = ''

      this.lingongSign = ''

      this.userNameSign = ''

      if (this.printData.manager_review && this.printData.document_status > 1) {
        this.lingongSign = `<img src="${SignObject['林源晟']}" />`
      }

      if (this.printData.document_status > 2) {
        this.caiwuSign = `<img src="${SignObject['连燕燕']}" />`
      }

      if (this.printData.document_status > 5) {
        this.lingdaoSign = `<img src="${SignObject['姚杨']}" />`
      }

      // 报销人
      if (SignObject[this.printData.users_name]) {
        this.userNameSign = `<img src="${SignObject[this.printData.users_name]}" />`
      } else {
        this.userNameSign = `&nbsp;${this.printData.users_name}`
      }

      this.$nextTick(() => {
        html2canvas(this.$refs.printHideDomRef, {
          backgroundColor: null
        }).then(canvas => {
          let dataURL = canvas.toDataURL('image/png')

          // document.getElementById('printImgDom').src = dataURL
          this.imgSrc = dataURL

          this.isShowImg = true
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.modalContainer {
  width: 100%;

  // display: flex;
  // justify-content: center;
  // flex-wrap: wrap;
}

/deep/ .printContainer {
  width: 774px;
  // height: 1103px;

  overflow: hidden;

  background-color: #fff;

  box-sizing: border-box;
  padding: 40px;
}

/deep/ .dateContainer {
  display: flex;
  justify-content: space-between;
}

/deep/ .titleContainer {
  text-align: center;
}

/deep/ .titleContainer h1 {
  font-size: 30px;
  font-weight: 400;
}

/deep/ .footerContainer {
  display: flex;
  justify-content: space-around;
}

/deep/ .footerContainer div {
  width: 20%;
}

/deep/ .mainTable {
  width: 100%;
  /* text-align: center; */
}

/deep/ table {
  /* text-align: center; */
  border-collapse: collapse;
  width: 100%;

  margin: 5px 0 15px 0;
}

/deep/ table td {
  box-sizing: border-box;
  padding: 20px;
  border: 1px solid #000000;

  height: 26px;

  font-size: 14px;
}

/deep/ .contentContainer {
  display: flex;
  justify-content: space-between;
}

/deep/ .signContainer {
  position: relative;
}

/deep/ .signItems {
  position: absolute;
  left: 70px;
  top: -10px;
}

/deep/ .signItems img {
  width: 80px;
}
</style>
